import { Directive, input } from '@angular/core';

@Directive({
  selector: '[loading]',
  standalone: false,
  host: {
    '[class.loading]': 'loading()',
    '[class.loading-ring]': 'loading()',
    '[class.loading-xs]': 'loading()'
  }
})
export class Loader {
  readonly loading=input.required<boolean>();

}